import { useQuery } from "@tanstack/react-query";
import { publicAxios } from "../axios";

export const getRGAFromLatLon = async (latlon?: string | null) => {
	const { data } = await publicAxios.get(`/georisques/rga/${latlon}`);
	return data;
};

export const useGetRGAFromLatLon = (latlon?: string | null) => {
	return useQuery({
		queryKey: ["rga", latlon],
		queryFn: async () => getRGAFromLatLon(latlon),
		enabled: false,
	});
};

export const getSismicFromLatLon = async (latlon?: string | null) => {
	const { data } = await publicAxios.get(`/georisques/sismic/${latlon}`);
	return data;
};

export const useGetSismicFromLatLon = (latlon?: string | null) => {
	return useQuery({
		queryKey: ["sismic", latlon],
		queryFn: async () => getSismicFromLatLon(latlon),
		enabled: false,
	});
};
